module.exports = __webpack_public_path__ + "static/button-action-dont-97f581c1bd97fb39432db7dde0c64dd5.png";